import { filterNotEmpty } from '@beeline.com/bp-design-system';
import { NotificationStatusModel, NotificationTypeModel } from '@utmost.co/enterprise-models';
import { ExportSource } from 'src/utils/hooks/data/exports/utils/Exports.types';
import { MappedNotification } from '../Notifications.types';
import { NotificationFragment } from 'src/providers/Notifications/utils/__generated__/GetUseNotifications.graphql';

export const EXPORT_TYPE: NotificationTypeModel[] = ['CSV_EXPORT', 'EXCEL_EXPORT'];

const IN_PROGRESS_STATUSES: NotificationStatusModel[] = ['IN_PROGRESS', 'QUEUED'];

const FAILED_STATUSES: NotificationStatusModel[] = ['FINISHED_ERROR'];

export const checkIsExportType = (notification: MappedNotification): boolean =>
  EXPORT_TYPE.includes(notification.type) && !!getExecutionId(notification);

export const checkIsWorkerQualificationType = (notification: NotificationFragment): boolean =>
  notification.type === 'WORKFLOW_NOTIFICATION' &&
  !!getWorkerQualificationUid(notification) &&
  !!getPersonUid(notification);

export const getExecutionId = (notification: MappedNotification): string | undefined =>
  notification.metadata?.find((data) => data?.key === 'EXECUTION_ID')?.value ?? undefined;

export const getWorkerQualificationUid = (notification: NotificationFragment): string | undefined | null =>
  notification.metadata?.find((data) => data?.key === 'targetWorkerQualificationUid')?.value;

export const getPersonUid = (notification: NotificationFragment): string | undefined | null =>
  notification.metadata?.find((data) => data?.key === 'targetPersonUid')?.value;

export const getEntityType = (
  notificationViewModel: Partial<MappedNotification> | MappedNotification
): ExportSource | undefined =>
  getMetaData(notificationViewModel)
    .find((e) => e?.key === 'ENTITY_TYPE')
    ?.value?.toLocaleLowerCase() as ExportSource;

export const checkIsNotInProgress = (status: NotificationStatusModel): boolean =>
  !IN_PROGRESS_STATUSES.includes(status);

export const checkIsFailed = (status: NotificationStatusModel): boolean => FAILED_STATUSES.includes(status);

export const isNotSupportedExportType = (notification: MappedNotification) =>
  ['organizations', 'users'].includes(getEntityType(notification) ?? '');

export const getMetaData = (notificationViewModel: Partial<MappedNotification>) =>
  notificationViewModel && Array.isArray(notificationViewModel?.metadata)
    ? filterNotEmpty(notificationViewModel.metadata)
    : [];

export const getNotificationState = (status: MappedNotification['status'] | undefined) => {
  const isReady = status === 'FINISHED_SUCCESS';
  const inProgress = status === 'IN_PROGRESS';
  const isQueued = status === 'QUEUED';
  const isError = status === 'FINISHED_ERROR';
  const isCancelled = status === 'CANCELLED';
  const isRejected = status === 'REJECTED';

  return {
    isReady,
    inProgress,
    isQueued,
    isError,
    isCancelled,
    isRejected
  };
};
